import { NgModule } from '@angular/core';

import { CheckboxComponent } from './checkbox.component';

@NgModule({
    imports: [CheckboxComponent],
    exports: [CheckboxComponent]
})
export class CheckboxModule {}
